import { getResultPoolRequestIds, getResult } from "Redux/Query";

export const getResultPoolRequest = state =>
    getResultPoolRequestIds(state).map( id => getResult(state, id)).filter( entry => !!entry );